// extracted by mini-css-extract-plugin
export default {"inputs-wrapper":"author_inputs-wrapper__o9jvY","author-wrapper":"author_author-wrapper__V52U2","input-item-wrapper":"author_input-item-wrapper__JJm6b"};